module.exports = __webpack_public_path__ + "static/media/jason.1cd30cc1.jpg";